import {Skeleton} from "@mui/material"
import {FC} from "react"
import {StyledTableRow, StyledTableCell} from "./TableStyles"

interface Props {
    rowCount: number
    cellCount: number
}

const TableLoadingMockup: FC<Props> = ({rowCount, cellCount}) => {
    return (
        <>
            {[...Array(rowCount)].map((item2, ind2) => (
                <StyledTableRow key={ind2}>
                    {[...Array(cellCount)].map((item, ind) => (
                        <StyledTableCell key={ind}>
                            <Skeleton height='60px' sx={{margin: 0}} key={ind}/>
                        </StyledTableCell>
                    ))}
                </StyledTableRow>
            ))}
        </>
    )
}

export default TableLoadingMockup